import React from 'react';
import Loader from 'react-spinners/PulseLoader';
import { useTheme } from '@material-ui/core/styles';
const PulseLoader = ({ size = 20, color }) => {
  const theme = useTheme();
  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
    >
      <Loader color={color || theme.palette.incorta.main || 'black'} size={size} />
    </div>
  );
};

export default PulseLoader;
